import type React from 'react';
import { useEffect } from 'react';
import trimStart from 'lodash/trimStart';

import HeaderNav from 'app/shared/modules/navigation/header/HeaderNav';
import Spinner from 'app/shared/modules/Spinner';

const FreepassRedirectPage: React.FC = () => {
  useEffect(() => {
    let redirectUri = window.location.href.split('/fp').pop();
    if (redirectUri) {
      redirectUri = trimStart(redirectUri, '/');
      redirectUri = `/${redirectUri}`;
      window.location.href = redirectUri;
    }
  }, []);

  return (
    <div>
      <HeaderNav />
      <Spinner className="Spinner-container" message="Redirecting..." />
    </div>
  );
};

export default FreepassRedirectPage;
